<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import WebAppIframe from './components/WebAppIframe.vue';
import AppChrome from './components/nav/AppChrome.vue';
import { updateServiceWorker } from '@/utils/app/registerServiceWorker';
import { useTranslator } from '@/composables/useTranslator';
import { eventBus } from '@/utils/core/eventBus';
import { useAppChrome } from '@/composables/useAppChrome';
const t = useTranslator();
const route = useRoute();
const isLegacyRoute = computed(() => !route.matched.length || Boolean(route.meta?.legacyView));
const { visible: chromeVisible, desktop } = useAppChrome();
const hasTopBar = computed(() => chromeVisible.value && desktop.value);
const showUpdateSnackbar = ref(false);
let pendingUpdate = false;
let externisReady = false;

function onUpdateAvailable() {
	if (externisReady) {
		// showUpdateSnackbar.value = true;
	} else {
		pendingUpdate = true;
	}
}

function onExternisReady() {
	externisReady = true;
	if (pendingUpdate) {
		// showUpdateSnackbar.value = true;
		pendingUpdate = false;
	}
}

function confirmUpdate() {
	showUpdateSnackbar.value = false;
	updateServiceWorker();
}

onMounted(() => {
	window.addEventListener('sw-update-available', onUpdateAvailable);
	eventBus.on('externis-ready', onExternisReady);
});

onUnmounted(() => {
	window.removeEventListener('sw-update-available', onUpdateAvailable);
	eventBus.off('externis-ready', onExternisReady);
});
</script>

<template>
	<v-app class="app-shell">
		<AppChrome />
		<v-main class="app-shell__main">
			<WebAppIframe :visible="isLegacyRoute" :safe-top="!hasTopBar" />
			<router-view />
		</v-main>
		<v-snackbar v-model="showUpdateSnackbar" :timeout="-1" location="bottom" rounded="xl">
			{{ t('New version available. Please refresh the page.') }}
			<template #actions>
				<v-btn variant="text" @click="showUpdateSnackbar = false">{{ t('Close') }}</v-btn>
				<v-btn color="primary" variant="text" @click="confirmUpdate">{{ t('Update') }}</v-btn>
			</template>
		</v-snackbar>
	</v-app>
</template>
